import React, { useEffect } from 'react';
import { useHistory, RouteComponentProps } from 'react-router';
import { useSearchParams } from 'hooks';
import { useUserOnboardingContext } from '../../../contexts/UserOnboardingContext';
import { ReviewTOSView as BaseReviewTOSView } from '../../common/ReviewTOSView';

export type ReviewTOSViewProps = RouteComponentProps<{ hash?: string }> & {
  handleGoBackStep: () => void;
  handleGoNextStep: () => void;
};

export const ReviewTOSView = (props: ReviewTOSViewProps) => {
  const { handleGoBackStep, handleGoNextStep } = props;
  const history = useHistory();
  const { ssoRedirect } = useSearchParams();

  const userOnboardingContext = useUserOnboardingContext();

  useEffect(() => {
    if (
      !userOnboardingContext?.userProfile.clientIdpFeatureEnabled &&
      !userOnboardingContext?.newPassword
    ) {
      handleGoBackStep();
    }
  }, [history, userOnboardingContext, handleGoBackStep]);

  return (
    <BaseReviewTOSView
      handleGoBackStep={handleGoBackStep}
      handleGoNextStep={handleGoNextStep}
      handleSubmit={() => userOnboardingContext.saveUserProfile(ssoRedirect)}
      {...props}
    />
  );
};
